import axios from 'axios';

type ErrorResponseBody = {
  message?: unknown;
  details?: Record<string, unknown>;
};

function toNonEmptyString(value: unknown): string | null {
  const isNonEmptyString = typeof value === 'string' && value.length > 0;
  if (!isNonEmptyString) return null;
  return value;
}

export function getErrorStatus(error: unknown): number | null {
  if (!axios.isAxiosError(error)) return null;
  return error.response?.status ?? null;
}

export function getServerMessage(error: unknown): string | null {
  if (!axios.isAxiosError<ErrorResponseBody>(error)) return null;
  return toNonEmptyString(error.response?.data?.message);
}

export function getFieldError(error: unknown, field: string): string | null {
  if (!axios.isAxiosError<ErrorResponseBody>(error)) return null;
  return toNonEmptyString(error.response?.data?.details?.[field]);
}
